export const useI18audioContextDetails = t => {
  const audioContextDetails = [
    {
      id: "channelCount",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.1"),
      description: "-",
    },
    {
      id: "channelCountMode",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.2"),
      description: "-",
    },
    {
      id: "channelInterpretation",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.3"),
      description: "-",
    },
    {
      id: "fftSize",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.4"),
      description: "-",
    },
    {
      id: "frequencyBinCount",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.5"),
      description: "-",
    },
    {
      id: "maxDecibels",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.6"),
      description: "-",
    },
    {
      id: "minDecibels",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.7"),
      description: "-1",
    },
    {
      id: "numberOfInputs",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.8"),
      description: "-",
    },
    {
      id: "numberOfOutputs",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.9"),
      description: "-",
    },
    {
      id: "smoothingTimeConstant",
      indicator: t("scannerFingerprint.JS.audioContextDetails.indicator.10"),
      description: "-",
    },
  ];

  return { audioContextDetails };
};
